import React from "react"
import { useSearchspringRecommendResults } from "@app/scripts/hooks/use-searchspring-recommend-results"

export function SearchDrawerSuggested() {
  const results = useSearchspringRecommendResults()

  const uniqueItems = results.reduce<{ name: string; url: string }[]>(
    (acc, item) => {
      if (acc.length >= 4) return acc
      if (
        !acc.some(
          (existing) => existing.name.toLowerCase() === item.name.toLowerCase()
        )
      ) {
        acc.push({ name: item.name, url: item.url })
      }
      return acc
    },
    []
  )

  return (
    <div className="search-drawer--menu-container">
      <h3 className="search-drawer--menu-title">Suggested</h3>
      <div className="search-drawer--suggested-items">
        {uniqueItems.map((item, index) => (
          <a
            key={index}
            href={item.url}
            className="search-drawer--suggested-item"
            aria-label={`View product: ${item.name}`}
          >
            {item.name.toLowerCase()}
          </a>
        ))}
      </div>
    </div>
  )
}
